import { CHANNEL_INFO_PARAMS } from 'routes'
import { usePanelActions } from 'routes/layouts/hooks/usePanelActions'

export function useNavigateToSubscription() {
    const { openPanel } = usePanelActions()
    return (spaceId: string) => {
        openPanel(CHANNEL_INFO_PARAMS.SINGLE_SUBSCRIPTION, {
            spaceId,
        })
    }
}
